
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[identifier]",
      function () {
        return require("private-next-pages/products/[identifier].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[identifier]"])
      });
    }
  